import map from 'lodash/map'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { routesDef } from '../../../../config/routes'
import { Row as RowCore } from '@ztechapps/webui.data-tools'
import { ShowIf } from '@ztechapps/webui.util'
import { useShowMore } from '@ztechapps/common.hook'
import { formatMoney } from '@ztechapps/common.utils'
import { OrderStatusBadge } from '@ztechapps/order.webui'
import { Link as LinkNative } from '@ztechapps/webui.util'
import { LocalDate } from '@ztechapps/webui.date'
import { QuantityWithUom } from '@ztechapps/product.webui'

export const Row = (props) => {
  const { items, code, _id, status, net, createdAt } = props

  const limit = 5
  const { newItems, setIsOpenMore, isOpenMore } = useShowMore({ items, limit })

  const codes = React.useMemo(() => {
    return map(newItems, (item) => {
      return (
        <Fragment key={item?._id}>
          <Link to={routesDef.ProductItemPage.altPath({ _id: item?.product?._id })}>{item?.product?.code} </Link>(
          <QuantityWithUom quantity={item?.quantity} symbol={item?.uom?.symbol} />
          ),{' '}
        </Fragment>
      )
    })
  }, [newItems])

  return (
    <RowCore {...props}>
      <td>
        <div className="d-flex">
          <OrderStatusBadge className="p-2 me-2" status={status} />
          <Link to={routesDef.AccountOrderItem.altPath({ _id })}>
            <div>{code} </div>
          </Link>
        </div>
        <div>
          <small>
            Items: {codes}
            <LinkNative onClick={setIsOpenMore}>
              <ShowIf condition={items?.length > limit}>
                <b> {isOpenMore ? 'Less...' : 'More...'}</b>
              </ShowIf>
            </LinkNative>
          </small>
        </div>
      </td>
      <td>
        <LocalDate value={createdAt} />
      </td>
      <td className="text-end">{formatMoney(net)}</td>
    </RowCore>
  )
}
